class FilterExposure extends HTMLElement {
  constructor () {
    super()
    this.state = {
      context: this.dataset.context,
    }
  }

  connectedCallback () {
    this.originalFilterItems = document.querySelectorAll(
      '[data-collection-exposed-filters-external-el="drawerItem"]',
    )

    if (this.state.context === 'nosto') {
      this.eventBus = window.theme.results.eventBus
      this.events = window.theme.results.events
      this.subscribeToEvents()
    } else {
      this.initialize()
    }
  }

  initialize () {
    this.newFilterItems = document.querySelectorAll(
      '[data-collection-exposed-filters-external-el="drawerTrigger"]',
    )

    if (this.newFilterItems.length > 0) {
      this.newFilterItems.forEach(trigger => {
        trigger.addEventListener('click', this.handleTriggerClick.bind(this))
      })
    }
  }

  subscribeToEvents () {
    this.eventBus.subscribe(this.events.STATE.FACETS_UPDATED, facets =>
      this.handleFacetsUpdated(facets),
    )
  }

  handleFacetsUpdated (facets) {
    this.innerHTML = ''
    facets.facets.forEach(facet => {
      this.insertAdjacentHTML('beforeend', this.templateExposedFilterTrigger(facet))
    })

    this.insertAdjacentHTML('beforeend', this.templateExposedSortTrigger())

    this.initialize()
  }

  handleTriggerClick (e) {
    const list = document.querySelector('.clc-ProductGridFacets_Items')
    const item = list.querySelector(`[data-filter-key="${e.target.dataset.filterKey}"]`)

    list.querySelectorAll('details').forEach(detail => {
      detail.removeAttribute('open')
    })

    if (item) {
      if (item.dataset.filterKey === e.target.dataset.filterKey) {
        item.querySelector('details').setAttribute('open', true)
      } else {
        item.querySelector('details').removeAttribute('open')
      }
    }
  }

  templateExposedFilterTrigger (filter) {
    return `
      <button
          type="button"
          class="clc-Filters_ListItem"
          data-filter-key="${filter.field}"
          data-module-drawers-trigger="results-collection-filters"
          data-collection-exposed-filters-external-el="drawerTrigger"
        >
          ${filter.name}
        </button>
    `
  }

  templateExposedSortTrigger () {
    return `
        <button
          type="button"
          class="clc-Filters_ListItem"
          data-filter-key="sort"
          data-module-drawers-trigger="results-collection-filters"
          data-collection-exposed-filters-external-el="drawerTrigger"
        >
          Sort By
        </button>
      `
  }
}

if (!customElements.get('filter-exposure')) {
  customElements.define('filter-exposure', FilterExposure)
}
